<template>
  <div style="padding: 22px 0; height: 100%;">
    <div class="agreement_layout">
      <aside class="layout_aside">
        <router-link class="link" replace v-for="route in menus" :key="route.name" :to="{ name: route.name, query: { ocode: ocode } }">
          {{ route.title }}
        </router-link>
      </aside>
      <main class="layout_main">
        <h3>{{ title }}</h3>
        <div class="pb-3"> <router-view /></div>
      </main>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
export default {
  name: '',
  data() {
    return {
      menus: [
        {
          title: '关于我们',
          name: 'about'
        },
        {
          title: '用户协议',
          name: 'user'
        },
        {
          title: '隐私条款',
          name: 'privacy'
        },
        {
          title: '法律声明',
          name: 'law'
        },
        {
          title: '联系我们',
          name: 'contact'
        }
      ],
       ocode: Vue.ls.get('code'),
    }
  },
  computed: {
    title() {
      return this.$route.meta.title
    }
  },
  methods: {}
}
</script>
<style lang="less" scoped>
.agreement_layout {
  width: 1200px;
  height: 100%;
  display: flex;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 15px;
  .layout_aside {
    width: 260px;
    padding: 15px;
    border-right: 1px solid #CED3DC;
    font-size: 16px;
    .link {
      display: block;
      // padding: 2px 5px;
      padding-left: 8px;
      height: 39px;
      line-height: 39px;
      color: #000;
    }
    .router-link-active {
      color: #1564FF;
      background-color: #F5F8FA;
      border-radius: 3px;
    }
  }
  .layout_main {
    flex: 1;
    padding: 0 14px;
    color: #000;
    h3 {
      height: 54px;
      line-height: 54px;
      margin-bottom: 24px;
      font-size: 16px;
      border-bottom: 1px solid #C8D1EE;
      font-weight: bold;
    }
  }
}
</style>
